import { SxProps, Theme } from '@mui/material'

export const theIncCertificationCardSx: SxProps<Theme> = {
  borderRadius: '0.8rem',
  width: {
    xs: '5.9rem',
    md: '22rem',
  },
  maxWidth: {
    xs: '5.9rem',
    md: '22rem',
  },
  height: {
    xs: '5.9rem',
    md: '7.4rem',
  },
  display: 'flex',
  alignItems: 'center',
  padding: {
    xs: '0.6rem',
    lg: '0.8rem',
  },
  zIndex: 1,
}

export const womanOfTheYearCertificationCardSx: SxProps<Theme> = {
  borderRadius: '0.8rem',
  width: {
    xs: '5.9rem',
    md: '20.8rem',
  },
  maxWidth: {
    xs: '5.9rem',
    md: '20.8rem',
  },
  height: {
    xs: '5.9rem',
    md: '7.4rem',
  },
  display: 'flex',
  alignItems: 'center',
  padding: {
    xs: '0.6rem 0.3rem',
    lg: '0.8rem',
  },
  zIndex: 1,
}

export const certificationsWrapperSx: SxProps<Theme> = {
  gap: {
    xs: '0.8rem',
    md: '1.2rem',
  },
  margin: {
    lg: 0,
  },
  justifyContent: 'center',
}

export const theIncCertificationImageSx: SxProps<Theme> = {
  minWidth: {
    md: '5.8rem',
  },
  minHeight: {
    md: '5.8rem',
  },
  width: {
    xs: '100%',
    md: '5.8rem',
  },
  height: {
    xs: '100%',
    md: '5.8rem',
  },
}

export const genericCertificationCardSx: SxProps<Theme> = {
  borderRadius: '0.8rem',
  display: 'flex',
  alignItems: 'center',
  padding: '0.8rem',
  zIndex: 1,
  flex: 1,
  maxWidth: {
    xs: '13.2rem',
    md: '16.4rem',
  },
  height: {
    xs: '5.9rem',
    md: '7.4rem',
  },
}
export const womanOfTheYearCertificationImageSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  objectFit: {
    xs: 'cover',
    md: 'contain',
  },
}
export const NMSDCCertificationImageSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  objectFit: {
    xs: 'cover',
    md: 'contain',
  },
}

export const genericCertificationImageSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
}

export const theIncCertificationTextSx: SxProps<Theme> = {
  marginLeft: '0.8rem',
  whiteSpace: 'pre-line',
  minWidth: 'max-content',
  textAlign: 'left',
}
